import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PDFProgressData } from 'ng2-pdf-viewer';

@Component({
    templateUrl: './pdf-modal.component.html',
    styles: [
        `:host ::ng-deep .ng2-pdf-viewer-container {
            overflow-x: inherit !important;
        }`
    ]
})
export class PdfModalComponent implements OnInit {

    pdf;
    imagen;
    rotation = 0;
    zoom = 1;
    // originalSize = false;
    progreso = 0;
    color = 'accent';
    mode = 'determinate';

    constructor(
        private dialogRef: MatDialogRef<PdfModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data
    ) { }

    ngOnInit() {

    }
    onProgress(progressData: PDFProgressData) {
        this.progreso = (progressData.loaded / progressData.total) * 100;
      }

    onNoClick(): void {
        this.dialogRef.close();
    }
    aumentarZoom(){
        this.zoom = this.zoom === 10 ? this.zoom = 10 : this.zoom + 0.25;
    }
    disminuirZoom(){
        this.zoom = this.zoom === 0 ? this.zoom = 0 : this.zoom - 0.25;
    }
    rotarDerecha(){
        this.rotation = this.rotation === 270 ? this.rotation = 0 : this.rotation + 90;
    }
    rotarIzquierda(){
        this.rotation = this.rotation === 0 ? this.rotation = 270 : this.rotation - 90;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/pdf-modal/pdf-modal.component.ts